export default "__VITE_ASSET__Ct6he3N0__"